import LanguageIcon from '@portalterreno/react-ui-icons/LanguageIcon';
import { useTranslation } from 'next-i18next';

import StyledTypography from '../StyledTypography';
import StyledBottomDiv from './StyledBottomDiv';
import StyledCountryDiv from './StyledCountryDiv';
import StyledH3Div from './StyledH3Div';

export type StyledBottomProps = React.HTMLAttributes<HTMLDivElement>;

const StyledBottom: React.FC<StyledBottomProps> = ({ ...rest }) => {
  const { t } = useTranslation('common');
  return (
    <StyledBottomDiv {...rest}>
      <StyledCountryDiv>
        <LanguageIcon />
        <StyledTypography
          color='white'
          variant='text'
        >
          {t('footerCountry')}
        </StyledTypography>
      </StyledCountryDiv>
      <StyledH3Div>
        <StyledTypography
          color='white'
          variant='text'
        >
          {t('copyright')}
        </StyledTypography>
      </StyledH3Div>
    </StyledBottomDiv>
  );
};

export default StyledBottom;
